import { render, staticRenderFns } from "./DiavImportView.vue?vue&type=template&id=2eb2ca01&scoped=true"
import script from "./DiavImportView.vue?vue&type=script&lang=js"
export * from "./DiavImportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb2ca01",
  null
  
)

export default component.exports